import { Method } from 'axios';
import { TRAVELER_MANAGEMENT_SERVICE_BASE_URL, httpVerbs } from 'configs';
import request from 'utils/axios';
import { DocumentUnsubscribeAlertsResponse, DocumentUnsubscribeAlertsPayload } from './types';

const SEGMENT = `${TRAVELER_MANAGEMENT_SERVICE_BASE_URL}/api/v1`;

export const unsubscribeDocumentAlerts = async (
  agencyId: string | undefined,
  travelerId: string | undefined,
  payload: DocumentUnsubscribeAlertsPayload,
): Promise<DocumentUnsubscribeAlertsResponse> => {
  const url = `${SEGMENT}/${agencyId}/traveler/notification-opt-out/${travelerId}`;
  return await request({ url, method: httpVerbs.PUT as Method, data: payload, headerVariant: 'public' });
};
